import './AccionesRolesGrid.scss';
import React, { useContext, useState, useRef, useEffect, useMemo } from 'react';
import { AccionesRolesContext } from '../../../../context/accionesroles/AccionesRolesContext';
import useDocumentTitle from '../../../../components/Title';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Switch, Typography, Grid } from '@mui/material';

const AccionesRolesGrid = ({ idRol, nombreRol }) => {
  useDocumentTitle("Lista de Acciones");
  const contexto = useContext(AccionesRolesContext);
  const {
    getAccionesRolesListaData,
    postAccionRolData,
    deleteAccionRolData,
    getAccionesListaData
  } = contexto;

  const [selectedModule, setSelectedModule] = useState(null);
  const [accionesRolesData, setAccionesRolesData] = useState(null);
  const [accionesData, setAccionesData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const isFetchingRef = useRef(false);

  useEffect(() => {
    fetchData();
  }, [idRol]);

  const fetchData = async () => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const dataEntityAcciones = await getAccionesListaData();
      setAccionesData(dataEntityAcciones);
      console.error("accionesData:", dataEntityAcciones);
      const dataEntityRolesAcciones = await getAccionesRolesListaData();
      setAccionesRolesData(dataEntityRolesAcciones);
      console.error("accionesRolesData:", dataEntityRolesAcciones);
    } catch (error) {
      console.error("Error al obtener datos:", error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const groupedActions = useMemo(() => {
    return (accionesData || []).reduce((acc, action) => {
      const [accion, modulo] = action.id.split(':');
      if (!acc[modulo]) {
        acc[modulo] = { modulo, acciones: [] };
      }
      acc[modulo].acciones.push({
        id: accion,
        descripcion: action.descripcion || accion,
      });
      return acc;
    }, {});
  }, [accionesData]);

  const getActionState = (accion, modulo) => {
    return accionesRolesData?.some(roleAction => roleAction?.accion_id === `${accion}:${modulo}`) || false;
  };

  const handleSwitchChange = async (accion, modulo) => {
    const currentState = getActionState(accion, modulo);

    try {
      if (currentState) {
        const action = accionesRolesData?.find(roleAction => roleAction?.accion_id === `${accion}:${modulo}`);
        if (action) await deleteAccionRolData(action.id);
      } else {
        const newAction = {
          rol_id: idRol,
          accion_id: `${accion}:${modulo}`,
          estado: true,
        };
        await postAccionRolData(newAction);
      }
      fetchData();
    } catch (error) {
      console.error("Error al cambiar el estado de la acción:", error);
    }
  };

  const cellStyle = { height: '20px', padding: '0px', wordWrap: 'break-word' };

  if (isLoading) {
    return (
      <Typography variant="h6" align="center">
        Cargando datos...
      </Typography>
    );
  }

  return (
    <Grid container spacing={3} className="acciones-roles-grid">
      <Grid item xs={12} md={4}>
        <TableContainer
          component={Paper}
          className="module-table"
          style={{ maxHeight: '300px', overflowY: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow style={cellStyle}>
                <TableCell style={{...cellStyle,width: '150px', maxWidth: '150px', whiteSpace: 'nowrap' }}>
                  Módulo
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(groupedActions).map((modulo) => (
                <TableRow
                  key={modulo}
                  onClick={() => setSelectedModule(modulo)}
                  style={{...cellStyle,
                    cursor: 'pointer',
                    backgroundColor: selectedModule === modulo ? '#f0f0f0' : 'inherit',
                  }}>
                  <TableCell style={{...cellStyle,textAlign: 'center' }}>
                    <Button style={{ textAlign: 'center' }}>
                      {modulo}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      {selectedModule && groupedActions[selectedModule] && (
        <Grid item xs={12} md={8}>
          <TableContainer component={Paper} className="permissions-table">
            <Typography variant="h6" style={{ padding: '10px' }}>
              Permisos del módulo: {selectedModule}
            </Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={cellStyle}>N°</TableCell>
                  <TableCell style={cellStyle}>Permiso</TableCell>
                  <TableCell style={cellStyle}>Estado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
               {groupedActions[selectedModule].acciones.map((accion, index) => (
  <TableRow key={index} style={cellStyle}>
    <TableCell style={cellStyle}>{index +1}</TableCell>
    <TableCell style={cellStyle}>{accion.descripcion}</TableCell>
    <TableCell style={cellStyle}>
      <Switch
        checked={getActionState(accion.id, selectedModule)}
        onChange={() => handleSwitchChange(accion.id, selectedModule)}
        inputProps={{ 'aria-label': 'controlled' }}
      />
    </TableCell>
  </TableRow>
))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
    </Grid>
  );
};

export default AccionesRolesGrid;
